export interface MoreInformationInterface {
    key: Number;
    value: String;
}
export const MoreInformation: MoreInformationInterface[] = [
    { key: 0, value: 'Saiba mais' },
    { key: 1, value: 'Clique aqui' },
    { key: 2, value: 'Acesse aqui' },
    { key: 3, value: 'Assista aqui' },
]